export const eventDiscountsAPIs = {
  add: {
    url: 'eventDiscounts',
    method: 'post',
    isAuthEnabled: true,
  },
  delete: {
    url: 'eventDiscounts',
    method: 'delete',
    isAuthEnabled: true,
  },
  get: {
    url: 'eventDiscounts',
    method: 'get',
    isAuthEnabled: true,
  },
  update: {
    url: 'eventDiscounts',
    method: 'patch',
    isAuthEnabled: true,
  },
};
